import { Component, Input } from '@angular/core';
import { AnnotationListItem } from '../../graphs-base.component';

@Component({
  selector: 'app-annotation-list',
  templateUrl: './annotation-list.component.html',
  styleUrl: './annotation-list.component.css',
  standalone: false,
})
export class AnnotationListComponent {
  @Input() items: AnnotationListItem[] = [];
}
